<nav class="btn-toolbar justify-content-between my-2" role="toolbar">
  <div class="btn-group btn-group-sm" role="group">
    @if (page <= 1) {
      <button class="btn btn-outline-secondary" disabled>
        <i class="fa fa-fast-backward"></i>
      </button>
    }
    @if (page <= 1) {
      <button class="btn btn-outline-secondary mx-1" disabled>
        <i class="fa fa-backward"></i>
      </button>
    }
    @if (page > 1) {
      <a [routerLink]="[actionName]" [queryParams]="{ page: 1, limit: limit }" class="btn btn-outline-secondary">
        <i class="fa fa-fast-backward"></i>
      </a>
    }
    @if (page > 1) {
      <a [routerLink]="[actionName]" [queryParams]="{ page: page - 1, limit: limit }" class="btn btn-outline-secondary mx-1">
        <i class="fa fa-backward"></i>
      </a>
    }
    @if (page < pageCount) {
      <a [routerLink]="[actionName]" [queryParams]="{ page: page + 1, limit: limit }" class="btn btn-outline-secondary mr-1">
        <i class="fa fa-forward"></i>
      </a>
    }
    @if (page < pageCount) {
      <a [routerLink]="[actionName]" [queryParams]="{ page: pageCount, limit: limit }" class="btn btn-outline-secondary">
        <i class="fa fa-fast-forward"></i>
      </a>
    }
    @if (page >= pageCount) {
      <button class="btn btn-outline-secondary mr-1" disabled>
        <i class="fa fa-forward"></i>
      </button>
    }
    @if (page >= pageCount) {
      <button class="btn btn-outline-secondary" disabled>
        <i class="fa fa-fast-forward"></i>
      </button>
    }
  </div>
  <div class="input-group input-group-sm">
    <p class="form-control-plaintext form-control-sm">
      Show
      @for (i of limits; track i) {
        <a [routerLink]="[actionName]" [queryParams]="{ page: page, limit: i }" class="mx-1" [class.font-weight-bold]="i == limit">{{i}}</a>
      }
      <span class="mx-1">|</span>
      Page <b class="mx-1">{{page}}</b> of <b class="mx-1">{{pageCount}}</b>
    </p>
  </div>
</nav>
